import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { SmallProduct } from "./Product";
import Side from "./Cart/Side";
import Button from "./Button";
import { useMediaQuery } from "react-responsive";
import { useSelector, useDispatch } from "react-redux";
import { getSearchProducts } from "../redux/app/search-input/actions";
import { logout } from "../redux/app/auth/actions";
import { clearCart } from "../redux/app/cart/actions";
import MobileMenu from "./MobileMenu";
import qs from "query-string";

function Header() {
  const navigate = useNavigate();
  const ref = useRef();
  const [showSearch, setSearch] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [isVisible, setVisibility] = useState(null);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { length } = useSelector((state) => state.cart);
  const { length: wishlistLength } = useSelector((state) => state.wishlist);
  const { categories } = useSelector((state) => state.categories);
  const { products, isLoading } = useSelector((state) => state.searchInput);
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const dispatch = useDispatch();
  const { search, pathname } = useLocation();
  const { c, q } = qs.parse(search);
  const [activePage, setActivePage] = useState(null);

  useEffect(() => {
    active();
  }, [c, categories]);

  useEffect(() => {
    if (!q && ref.current.value) ref.current.value = "";
  }, [q]);

  useEffect(() => {
    if (isVisible) setVisibility(false);
    if (mobileMenu) setMobileMenu(false);
  }, [pathname]);

  const handleChange = (event) => {
    const val = event.target.value;
    if (val.length >= 2) {
      dispatch(getSearchProducts(val));
      setSearch(true);
    } else setSearch(false);
  };

  const handleKeyDown = (event) => {
    const keyword = event.target.value;
    if (keyword.length >= 2 && event.keyCode === 13) {
      navigate(`/search?q=${keyword}`);
      setSearch(false);
    }
  };

  const handleFocus = (event) => {
    const val = event.target.value;
    if (val.length > 2) setSearch(true);
  };

  const handleBlur = () => {
    setTimeout(() => setSearch(false), 100);
  };

  const handleLogout = () => {
    dispatch(logout());
    dispatch(clearCart());
    localStorage.removeItem("cart");
  };

  const active = () => {
    if (!c || !categories) {
      setActivePage(null);
      return;
    }
    for (const [key, value] of categories.entries()) {
      if (value.category_id === c) {
        return setActivePage(c);
      }
      if (value.subs.length > 0) {
        for (let ctg of value.subs) {
          if (ctg.category_id === c) {
            return setActivePage(value.category_id);
          }
        }
      }
    }
  };

  const [show, setShow] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(300);

  const controlNavbar = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY < 100) {
        setShow(true);
      } else {
        setShow(false);
      }
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", controlNavbar);
      return () => {
        window.removeEventListener("scroll", controlNavbar);
      };
    }
  }, [lastScrollY]);

  return (
    <>
      <header>
        <div className="top-header">
          <div className="container">
            <div className="d-flex align-center logo-container">
              <Link to="/">
                <img src="/assets/images/point-logo-final.png" alt="Point logo" />
              </Link>
            </div>

            <div className="search-container">
              <img
                className="icon"
                src="/assets/images/search.svg"
                alt="Search icon"
              />
              <input
                type="text"
                ref={ref}
                placeholder="Search"
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
              />

              {showSearch && (
                <div
                  className={`search-results small-products ${isLoading && "loader"
                    }`}
                >
                  <div className="search-scroll">
                    {products.length > 0 &&
                      products.map((item) => (
                        <SmallProduct key={item.product_id} item={item} />
                      ))}
                    {products.length <= 0 && <p>No data found.</p>}
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex align-center actions">
              <Button
                onClick={() => setVisibility("shopping")}
                icon={
                  <div className="icon-container price-badge-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.995"
                      height="21.503"
                      viewBox="0 0 18.995 21.503"
                    >
                      <g
                        id="Group_3"
                        data-name="Group 3"
                        transform="translate(-558.502 -189.255)"
                      >
                        <path
                          id="Vector"
                          d="M0,5.662v-.97A4.773,4.773,0,0,1,4.06.022,4.5,4.5,0,0,1,9,4.5v1.38"
                          transform="translate(563.5 190.008)"
                          fill="none"
                          stroke="#FFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        />
                        <path
                          id="Vector-2"
                          data-name="Vector"
                          d="M5.751,14.008h6c4.02,0,4.74-1.611,4.95-3.572l.75-6c.27-2.441-.43-4.433-4.7-4.433h-8C.481,0-.219,1.991.051,4.433l.75,6C1.011,12.4,1.731,14.008,5.751,14.008Z"
                          transform="translate(559.249 196)"
                          fill="none"
                          stroke="#FFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        />
                        <path
                          id="Vector-3"
                          data-name="Vector"
                          d="M.495.5H.5"
                          transform="translate(571.001 199.504)"
                          fill="none"
                          stroke="#FFf"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        />
                        <path
                          id="Vector-4"
                          data-name="Vector"
                          d="M.495.5H.5"
                          transform="translate(564 199.504)"
                          fill="none"
                          stroke="#FFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        />
                      </g>
                    </svg>
                    {length > 0 && (
                      <span className="price-badge">{length}</span>
                    )}
                  </div>
                }
              />

              <Button
                onClick={() => setVisibility("wishlist")}
                icon={
                  <div className="icon-container price-badge-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21.5"
                      height="19.521"
                      viewBox="0 0 21.5 19.521"
                    >
                      <path
                        id="Vector"
                        d="M10.62,17.909a2.157,2.157,0,0,1-1.24,0C6.48,16.908,0,12.731,0,5.653A5.606,5.606,0,0,1,5.56,0,5.5,5.5,0,0,1,10,2.265,5.51,5.51,0,0,1,14.44,0,5.606,5.606,0,0,1,20,5.653C20,12.731,13.52,16.908,10.62,17.909Z"
                        transform="translate(0.75 0.75)"
                        fill="none"
                        stroke="#FFF"
                       strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </svg>
                    {wishlistLength > 0 && (
                      <span className="price-badge">{wishlistLength}</span>
                    )}
                  </div>
                }
              />

              {isMobile ? (
                <Button
                  onClick={() => setMobileMenu(true)}
                  icon={
                    <svg
                      id="fi-rr-align-right"
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.293"
                      height="13.666"
                      viewBox="0 0 19.293 13.666"
                    >
                      <path
                        id="Path_336"
                        data-name="Path 336"
                        d="M.8,5.608H18.49A.8.8,0,0,0,18.49,4H.8a.8.8,0,0,0,0,1.608Z"
                        transform="translate(0 -4)"
                        fill="#fff"
                      />
                      <path
                        id="Path_337"
                        data-name="Path 337"
                        d="M20.058,9H8.8a.8.8,0,0,0,0,1.608H20.058a.8.8,0,0,0,0-1.608Z"
                        transform="translate(-1.569 -4.981)"
                        fill="#fff"
                      />
                      <path
                        id="Path_338"
                        data-name="Path 338"
                        d="M20.058,19H8.8a.8.8,0,0,0,0,1.608H20.058a.8.8,0,0,0,0-1.608Z"
                        transform="translate(-1.569 -6.942)"
                        fill="#fff"
                      />
                      <path
                        id="Path_339"
                        data-name="Path 339"
                        d="M18.49,14H.8a.8.8,0,0,0,0,1.608H18.49a.8.8,0,0,0,0-1.608Z"
                        transform="translate(0 -5.961)"
                        fill="#fff"
                      />
                    </svg>
                  }
                />
              ) : isAuthenticated ? (
                <div className="logged-in dropdown">
                  <div className="icon-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.68"
                      height="21.5"
                      viewBox="0 0 18.68 21.5"
                    >
                      <g
                        id="Group_2"
                        data-name="Group 2"
                        transform="translate(-110.66 -189.25)"
                      >
                        <path
                          id="Vector"
                          d="M10,5A5,5,0,1,1,5,0,5,5,0,0,1,10,5Z"
                          transform="translate(115 190)"
                          fill="none"
                          stroke="#FFF"
                         strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        />
                        <path
                          id="Vector-2"
                          data-name="Vector"
                          d="M17.18,7c0-3.87-3.85-7-8.59-7S0,3.13,0,7"
                          transform="translate(111.41 203)"
                          fill="none"
                          stroke="#FFF"
                         strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        />
                      </g>
                    </svg>
                    <div className="dropdown-items">
                      <Link to="/profile">Profili</Link>
                      <Link to="/orders">Historia e porosive</Link>
                      <Link to="" onClick={handleLogout}>
                        Ç’kyqu
                      </Link>
                    </div>
                  </div>
                </div>
              ) : (
                <NavLink to="/login">
                  <div className="icon-container">
                    <svg
                      id="fi-rr-user"
                      xmlns="http://www.w3.org/2000/svg"
                      width="15.052"
                      height="20.069"
                      viewBox="0 0 15.052 20.069"
                    >
                      <path
                        id="Path_672"
                        data-name="Path 672"
                        d="M11.017,10.034A5.017,5.017,0,1,0,6,5.017a5.017,5.017,0,0,0,5.017,5.017Zm0-8.362A3.345,3.345,0,1,1,7.672,5.017,3.345,3.345,0,0,1,11.017,1.672Z"
                        transform="translate(-3.491 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_673"
                        data-name="Path 673"
                        d="M10.526,14A7.534,7.534,0,0,0,3,21.526a.836.836,0,1,0,1.672,0,5.853,5.853,0,0,1,11.707,0,.836.836,0,1,0,1.672,0A7.534,7.534,0,0,0,10.526,14Z"
                        transform="translate(-3 -2.293)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </NavLink>
              )}
            </div>
          </div>
        </div>

        {!isMobile && (
          <nav className={`menu active ${show ? "" : "nav-menu-hidden"}`}>
            <ul className={`container ${!categories && "loader"} `}>
              {categories &&
                [...categories.keys()].map((item) => {
                  const category = categories.get(item);
                  return (
                    <li className="dropdown" key={category.category_id}>
                      <Link
                        className={activePage === item ? "active" : null}
                        to={`/search?c=${category.category_id}`}
                      >
                        {category.category}


                      </Link>
                      {category.subs.length > 0 && (
                        <div className="dropdown-items">
                          {category.subs.map((item) => (
                            <Link
                              to={`/search?c=${item.category_id}`}
                              key={item.category_id}
                            >
                              <img
                                src={item?.main_pair?.detailed?.image_path}
                                alt={item.category}
                              />
                              <span style={{ display: "block", width: "100%" }}>
                                {item.category}
                              </span>
                            </Link>
                          ))}
                        </div>
                      )}
                    </li>
                  );
                })}
            </ul>
          </nav>
        )}
        {isMobile && (
          <div className="search-container mobile-search">
            <img
              className="icon"
              src="/assets/images/search-black.svg"
              alt="Search icon"
            />
            <input
              type="text"
              placeholder="Search"
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
            />

            {showSearch && (
              <div className={`search-results small-products`}>
                <div className="search-scroll">
                  {products.length > 0 &&
                    products.map((item) => (
                      <SmallProduct key={item.id} item={item} />
                    ))}
                  {products.length <= 0 && <p>No data found.</p>}
                </div>
              </div>
            )}
          </div>
        )}
      </header>
      <Side isVisible={isVisible} setVisibility={setVisibility} />
      {isMobile && (
        <MobileMenu mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} />
      )}
    </>
  );
}

export default Header;
